export const PAGES_MENU = [
  {
    path: "pages",
    children: [
      {
        path: null,
        data: {
          menu: {
            title: "Menú",
            icon: "",
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: "home",
        data: {
          menu: {
            title: "Inicio",
            icon: "ion-home",
            selected: false,
            expanded: false,
            order: 0,
            isHome: true
          }
        }
      },
      {
        path: null,
        data: {
          menu: {
            title: "Principal",
            icon: "",
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: "personal",
        data: {
          menu: {
            title: "Personal",
            icon: "ion-person-add",
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: "registerHours",
        data: {
          menu: {
            title: "Registro de Horarios",
            icon: "ion-clock",
            pathMatch: "prefix",
            selected: false,
            expanded: false,
            order: 200
          }
        }
      },
      {
        path: "labor",
        data: {
          menu: {
            title: "Planillas de Control de Labores",
            icon: "ion-clipboard",
            pathMatch: "prefix",
            selected: false,
            expanded: false,
            order: 200
          }
        }
      },
      {
        path: "user",
        data: {
          menu: {
            title: "Usuarios",
            icon: "ion-person-stalker",
            selected: false,
            expanded: false,
            order: 0
          }
        }
      },
      {
        path: "logout",
        data: {
          menu: {
            title: "Salir",
            icon: "fa fa-sign-out",
            selected: false,
            expanded: false,
            order: 0
          }
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// /app/src/app/pages/pages.menu.ts